import React, { forwardRef, ReactNode } from 'react';

export const StageWrapper = forwardRef<HTMLDivElement, {
  children: ReactNode
}>(({ children }, ref) => (
  <div
    ref={ref}
    className="flex-shrink flex-1 h-full w-auto flex justify-center items-center min-w-0 relative overflow-hidden"
  >
    {children}
  </div>
));

StageWrapper.displayName = 'StageWrapper';
